<template>
  <div>
    <h3 class="float-left">药师远程沟通资料</h3>
    <el-table
      :data="videoRecordVos"
      border
      style="width: 100%"
      header-row-class-name="common-table-header"
      row-class-name="common-table-row"
      class=" common-table"
    >
      <el-table-column label="药师/店员">
        <template slot-scope="scope">
          {{ scope.row.role | RoleFilter }}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名/ID"></el-table-column>
      <el-table-column label="内容">
        <template slot-scope="scope">
          <span v-html="handlerContent(scope.row.videoUrl)"></span>
        </template>
      </el-table-column>
      <el-table-column label="时间">
        <template slot-scope="scope">
          {{ scope.row.time | parseTime(true) }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<style lang="scss" scoped>
.preview-image {
  width: 100px;
}
</style>
<script>
export default {
  name: 'pharmacistContactData',
  props: {
    videoRecordVos: Array
  },
  data() {
    return {};
  },
  filters: {
    RoleFilter(role) {
      return role == 'pharmacist' ? '药师' : '店员';
    }
  },
  methods: {
    handlerContent(videoUrl) {
      return /^https?:\/\/.+\.mp4$/.test(videoUrl.toLowerCase())
        ? `<video width="100%" height="100px" controls="controls" src="${videoUrl}"></video>`
        : '无';
    }
  }
};
</script>
